import styled from 'styled-components';
import {
  Link,
} from 'react-router';

import {
  Flex,
} from 'web-styled';

export const Search = styled(Flex).attrs({
  flex: '0 0 68px',
  align: 'center',
})`
  width: 100%;
  padding: 0 15px;

  & > div {
    width: 100%;
  }
`;

export const ClientsHeader = styled.div`
  padding: 0 15px;
`;

export const Item = styled(Flex).attrs({
  flex: '0 0 60px',
  justify: 'space-between',
})`
  margin: 0;
  width: 100%;
  padding: 15px;
  border-top: 1px solid #ededed;

  &:first-of-type {
    margin-top: 10px;
  }

  &:hover {
    background: #fbfbfb;
  }

  &:last-child {
    border-bottom: 1px solid #ededed;
  }

  &:hover div:last-of-type {
    visibility: visible;
  }

`;

export const Avatar = styled.img`
  width: 25px;
  height: 25px;
  border-radius: 50%;
`;

export const Name = styled(Link)`
 font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${props => props.theme.colors.link};
  line-height: 30px;

  & > i {
    margin: 0 5px;
    width: 23px;
    height: 13px;
  }
`;

export const Empty = styled(Flex).attrs({
  column: true,
  spacing: 10,
  align: 'center',
  justify: 'center',
})`
  width: 100%;
  height: 100%;
  color: #ccc;
  text-align: center;
`;

export const MoveBar = styled.div`
  visibility: hidden;
`;
